import { Link } from 'react-router-dom';
import type { Review } from '@/mocks/reviews';

interface ReviewCardProps {
  review: Review;
  featured?: boolean;
}

export default function ReviewCard({ review, featured = false }: ReviewCardProps) {
  return (
    <Link
      to={`/review/${review.id}`}
      className={`group block cursor-pointer overflow-hidden rounded-lg bg-background-900 border border-background-800 hover:border-primary-700/70 transition-colors ${
        featured ? 'md:flex' : ''
      }`}
    >
      <div className={`relative overflow-hidden bg-background-800 ${featured ? 'w-full md:w-2/5 aspect-[16/10] md:aspect-auto' : 'w-full aspect-[16/9]'}`}>
        <img
          src={review.cover}
          alt={`${review.title} 封面`}
          title={`${review.title} - 成人短剧影评`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      <div className={`flex flex-col p-5 ${featured ? 'md:w-3/5 md:p-7' : ''}`}>
        <div className="flex flex-wrap gap-2 mb-3">
          {review.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="rounded-full bg-accent-900/50 px-2.5 py-0.5 text-[11px] text-accent-200">
              {tag}
            </span>
          ))}
        </div>
        <h3 className={`font-bold text-foreground-50 group-hover:text-primary-300 transition-colors ${featured ? 'text-lg md:text-2xl' : 'text-base'}`}>
          {review.title}
        </h3>
        <p className={`mt-2.5 text-sm text-foreground-400 leading-relaxed ${featured ? 'md:line-clamp-3' : 'line-clamp-2'}`}>
          {review.excerpt}
        </p>
        <div className="mt-4 flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-user-line" />
            {review.author}
          </span>
          <span className="w-px h-3 bg-background-700" />
          <span>{review.date}</span>
          <span className="w-px h-3 bg-background-700" />
          <span>{review.readTime}</span>
        </div>
      </div>
    </Link>
  );
}